import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LightboxService {
  private _lightboxOpen: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  lightboxOpen$: Observable<boolean> = this._lightboxOpen.asObservable();
  imageUrl: any;

  constructor() {}

  openLightbox(imageUrl: any) {
    this.imageUrl = imageUrl;
    this._lightboxOpen.next(true);
  }

  closeLightbox() {
    this._lightboxOpen.next(false);
  }
}
